import { motion } from "framer-motion";
import { BedDouble } from "lucide-react";
import { ChapterHeading } from "@/components/ChapterHeading";

const stays = [
  {
    name: "Holiday Inn Southend Airport",
    detail: "The closest option — right beside the airport terminal, about five minutes by car from the venue.",
    address: "77 Eastwoodbury Crescent, Southend-on-Sea, SS2 6XG",
    mapUrl: "https://maps.google.com/?q=Holiday+Inn+Southend+Airport,+77+Eastwoodbury+Crescent,+SS2+6XG",
    testId: "stay-card-holiday-inn-airport",
  },
  {
    name: "Premier Inn Southend Airport",
    detail: "Reliable and good value on the A127 — roughly ten minutes from the venue.",
    address: "Thanet Grange, Princes Avenue, Southend-on-Sea, SS2 6GB",
    mapUrl: "https://maps.google.com/?q=Premier+Inn+Southend+Airport,+Princes+Avenue,+SS2+6GB",
    testId: "stay-card-premier-inn-airport",
  },
  {
    name: "Holiday Inn Rayleigh",
    detail: "At Rayleigh Weir on the A127 — around fifteen minutes from the venue.",
    address: "Arterial Road, Rayleigh, SS6 7SP",
    mapUrl: "https://maps.google.com/?q=Holiday+Inn+Rayleigh,+Arterial+Road,+SS6+7SP",
    testId: "stay-card-holiday-inn-rayleigh",
  },
];

export const StayChapter = () => (
  <section className="px-6 py-24 md:px-16 md:py-36 lg:px-24" data-testid="chapter-stay">
    <ChapterHeading number="03" title="Where to" italic="Stay" testId="chapter-stay-heading" />

    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="relative mb-6 overflow-hidden border border-white/10"
      data-testid="stay-image-card"
    >
      <img
        src="https://images.unsplash.com/photo-1711059985570-4c32ed12a12c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxib3V0aXF1ZSUyMGhvdGVsJTIwcm9vbSUyMG1vb2R5fGVufDB8fHx8MTc4NzgzNzY0NHww&ixlib=rb-4.1.0&q=85"
        alt="A moody boutique hotel room"
        className="h-72 w-full object-cover md:h-96"
      />
      <div className="absolute inset-0 bg-black/30" />
      <p className="absolute bottom-6 left-8 text-xs uppercase tracking-[0.3em] text-[#F5F5F0]">
        Travelling in? Stay the night — no one drives home after a great party.
      </p>
    </motion.div>

    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {stays.map((stay, i) => (
        <motion.div
          key={stay.testId}
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          whileHover={{ y: -4 }}
          className="group border border-white/10 bg-[#0D0D0D] p-10 transition-colors duration-300 hover:border-gold/30"
          data-testid={stay.testId}
        >
          <BedDouble className="mb-8 h-5 w-5 text-gold transition-transform duration-300 group-hover:-translate-y-1" strokeWidth={1.25} />
          <p className="font-display text-2xl font-light text-[#F5F5F0]">{stay.name}</p>
          <p className="mt-4 text-sm leading-relaxed text-[#A1A19A]">{stay.detail}</p>
          <p className="mt-6 text-xs leading-relaxed tracking-wide text-[#666666]">{stay.address}</p>
          <a
            data-testid={`${stay.testId}-map-link`}
            href={stay.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-block border-b border-gold/50 pb-1 text-xs uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:border-gold hover:text-gold-hover"
          >
            Open in Maps
          </a>
        </motion.div>
      ))}
    </div>
  </section>
);
